// Taken from the Modernizr lib. Code has been cleaned and simplified to only answer our needs
// Safari media query does not include the scroll bar, which creates a mismatch between JS and CSS
// https://github.com/Modernizr/Modernizr/blob/master/src/mq.js

const isMatchingMediaQuery = query => {
  const id = `media-query-test-${query.replace(/\s|:|\(|\)/g, '')}`

  if (!document.contains(document.getElementById(id))) {
    const style = document.createElement('style')
    style.type = 'text/css'
    document.head.appendChild(style)

    const rule = `
    #${id} {
      visibility: hidden;
      display: none;
    }

    @media ${query} {
      #${id} {
        display: block;
      }
    }
  `
    style.appendChild(document.createTextNode(rule))

    const div = document.createElement('div')
    div.id = id
    document.body.appendChild(div)
  }

  return !!document.getElementById(id).offsetParent
}

export default isMatchingMediaQuery
